export default "/react/gnezdo-148f569b.svg";